export default __webpack_public_path__ + "static/media/weblogoblue.85a0c363.png";